import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IProfile } from '../UserDetails/user.model'
@Injectable()
export class UserProfile {
    userProfile: IProfile = {
        access_token: "",
        expires_in: "",
        claim: null,
        name: null,
        status: null,
        isfirstime: null
    };
    constructor(private router: Router) {
    }
    setProfile(profile: IProfile): void {
        sessionStorage.setItem('access_token', profile.access_token);
        sessionStorage.setItem('expires_in', profile.expires_in);
        sessionStorage.setItem('user_name', profile.name);
    }

    getProfile(authorizationOnly: boolean = false): IProfile {
        var accessToken = sessionStorage.getItem('access_token');
        if (accessToken) {
            this.userProfile.access_token = accessToken;
            this.userProfile.expires_in = sessionStorage.getItem('expires_in');
        }
        return this.userProfile;
    }
    resetProfile(): IProfile {
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('expires_in');
        this.userProfile = {
            access_token: "",
            expires_in: "",
            claim: null,
            name: null,
            status: null,
            isfirstime: null
        };
        return this.userProfile;
    }

}